const rutasContexto = [

  //Version 1
  // carros
  // cerramientoUrbanismo * no se usa
  // comunal
  // duplicadores
  // urbanismoSauces
  // urbanismoFelicidad
  // vegetacionFelicidad
  // edificiosVecinos * no tiene textura

  //Version 2
  //rampaAccesoVehicular * tiene alpha
  //pastoInterior
  //contexto1
  //contexto2
  //anden
  //adoquinContexto1
  //adoquinContexto2
  //adoquinUrbanismo
  //cerramientoConjunto

  //Version3
  //adoquin 
  //arbustos 
  //materas 
  //carretera 



  //Modelos

  
  {
    name: "modelo_comunal",
    type: "gltfModel",
    path: "modelos/contexto/COMUNAL_FL.gltf",
  },
  {
    name: "modelo_cerramientoUrbanismo",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/CERRAMIENTO URBANISMO_FL.gltf",
  },
  {
    name: "modelo_cerramientoUrbanismo2",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/CERRAMIENTO_URBANISMO-2.gltf",
  },
  {
    name: "modelo_urbanismoSauces",
    type: "gltfModel",
    path: "modelos/contexto/PARQUEADEROS.glb",
    //path: "modelos/contexto/nuevo/PARQUEADEROS.gltf",
  },
  {
    name: "modelo_urbanismoGeneral",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/URBANISMO.gltf",
  },
  {
    name: "modelo_adoquinContexto",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/ADOQUIN_CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_edificiosVecinos",
    type: "gltfModel",
    path: "modelos/contexto/EDIFICIOS_VECINOS.gltf",
  },
  {
    name: "modelo_contexto2",
    type: "gltfModel",
    path: "modelos/contexto/CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_adoquinContexto2",
    type: "gltfModel",
    path: "modelos/contexto/ADOQUIN_CONTEXTO_02_FL.gltf",
  },
  {
    name: "modelo_carretera",
    type: "gltfModel",
    path: "modelos/contexto/CARRETERA_FL.gltf",
  },
  {
    name: "modelo_fondoMapa",
    type: "gltfModel",
    path: "modelos/contexto/FONDO_MAPAS BOGOTA_FL.gltf",
  },
  //
  {
    name: "modelo_plataforma",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/PLATAFORMA.glb",
  },
  {
    name: "modelo_duplicadores",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/DUPLICADORES.glb",
  }, 
  {
    name: "modelo_carros",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/CARROS.glb",
  },
  {
    name: "modelo_pasto",
    type: "gltfModel",
    path: "modelos/contexto/nuevo/PASTO_ANDEN.glb",
  },      
  
  //Texturas  
  {
    name: "text_comunal",
    type: "texture",
    path: "texturas/contexto/COMUNAL_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_urbanismoSauces",
    type: "texture",
    path: "texturas/contexto/PARQUEADEROS_Corona_DiffuseColor.webp",
    //path: "texturas/contexto/nuevo/PARQUEADEROS_Corona_DiffuseColor.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo",
    type: "texture",
    path: "texturas/contexto/nuevo/CERRAMIENTO URBANISMO_FL_Corona_Diffuse1.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo_alpha",
    type: "texture",
    path: "texturas/contexto/nuevo/CERRAMIENTO URBANISMO_FL_Corona_Alpha.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo2",
    type: "texture",
    path: "texturas/contexto/nuevo/FL_CERRAMIENTO CONJUNTO_2.webp",
    
  },
  {
    name: "text_cerramientoUrbanismo2_alpha",
    type: "texture",
    path: "texturas/contexto/nuevo/FL_CERRAMIENTO_CONJUNTO_ALPHA.webp",
    
  },
  {
    name: "text_urbanismoGeneral",
    type: "texture",
    path: "texturas/contexto/nuevo/URBANISMO LA FELICIDAD_FL_Corona_Diffuse2.webp",
  },
  {
    name: "text_adoquinContexto",
    type: "texture",
    path: "texturas/contexto/nuevo/ADOQUIN_UNRBANISMO LA FELICIDAD_FL_Corona_Diffuse_2.webp",
  },
  {
    name: "text_contexto2",
    type: "texture",
    path: "texturas/contexto/CONTEXTO_02_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_adoquinContexto2",
    type: "texture",
    path: "texturas/contexto/ADOQUIN_CONTEXTO_02_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_carretera",
    type: "texture",
    path: "texturas/contexto/CARRETERA_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_fondoMapa",
    type: "texture",
    path: "texturas/contexto/FONDO_MAPAS BOGOTA_FL_Corona_Diffuse2.webp",
  },
  {
    name: "text_plataforma",
    type: "texture",
    path: "texturas/contexto/nuevo/PLATAFORMA_Corona_DiffuseColor.webp",
  },
  //DUPLICADORES_Corona_DiffuseColor
  {
    name: "text_duplicadores",
    type: "texture",
    path: "texturas/contexto/nuevo/DUPLICADORES_Corona_DiffuseColor.webp",
  },
  //CARROS_Corona_DiffuseColor
  {
    name: "text_carros",
    type: "texture",
    path: "texturas/contexto/nuevo/CARROS_Corona_DiffuseColor.webp",
  },
  {
    name: "text_pasto",
    type: "texture",
    path: "texturas/contexto/nuevo/PASTO_ANDEN.webp",
  },
  
];

export default rutasContexto;
